var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPointsStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5D43E",
    d: "M96.219,42.43c0.618-0.607,1.002-1.451,1.002-2.385c0-1.847-1.497-3.164-3.344-3.164 c-0.276,0-0.891,0.119-0.891,0.119H62.941l-9.45-29.117c-0.165-1.693-1.592-3.107-3.328-3.107S47,6.055,46.835,7.748l-9.451,28.914 L6.775,36.729c-0.107-0.011-0.215-0.022-0.325-0.022c-1.847,0-3.344,1.494-3.344,3.341c0,1.071,0.505,2.02,1.288,2.632 l25.093,18.292L20.36,89.078c0,0-0.631,1.37-0.631,2.16c0,1.896,1.538,3.435,3.435,3.435c1.118,0,2.959-1.19,2.959-1.19 l24.04-17.468l23.434,17.021c0,0,1.717,1.11,2.771,1.11c1.996,0,3.614-1.618,3.614-3.614c0-0.351-0.527-1.757-0.527-1.757 L70.84,60.973L96.219,42.43z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEBF3B",
    d: "M41.979,36.768c4.063-8.398,8.652-16.1,13.522-22.908l-2.011-6.157c-0.165-1.693-1.592-3.017-3.328-3.017 S47,6.009,46.835,7.703l-9.45,28.937l-30.61,0.078c-0.107-0.011-0.215-0.017-0.325-0.017c-1.847,0-3.344,1.497-3.344,3.344 c0,1.071,0.505,2.022,1.289,2.634l25.093,18.292l-9.127,28.107c0,0-0.63,1.37-0.63,2.16c0,1.896,1.538,3.435,3.435,3.435 c1.118,0,2.959-1.19,2.959-1.19l1.728-1.255C27.553,76.72,32.291,56.794,41.979,36.768z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointsStar);
export default __webpack_public_path__ + "static/media/points-star.2ab79acd083607ef795292549d9e4be2.svg";
export { ForwardRef as ReactComponent };